export default [
  
  {
    path: '/zhtlive/index',
    name: 'index',
    component: () => import('@/views/zhtlive/index'),
    meta: {
      title: '专题列表'
    }
  },
  {
    path: '/zhtlive/zhtdetail/:id',
    name: 'zhtdetail',
    component: () => import('@/views/zhtlive/zhtdetail'),
    meta: {
      
    }
  },
 
]
